import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fee-selection"
export default class extends Controller {
  static targets = ["checkbox", "payButton", "total", "count"]
  static values = { summaryUrl: String }

  connect() {
    this.update()
  }

  update() {
    const selected = this.checkboxTargets.filter((checkbox) => checkbox.checked)
    const total = selected.reduce((sum, checkbox) => sum + parseFloat(checkbox.dataset.amount), 0)
    const disabled = selected.length === 0

    if (this.hasPayButtonTarget) {
      this.payButtonTarget.classList.toggle("opacity-50", disabled)
      this.payButtonTarget.classList.toggle("pointer-events-none", disabled)

      const params = new URLSearchParams()
      selected.forEach((checkbox) => params.append("payables[]", `${checkbox.dataset.type}-:-${checkbox.dataset.id}`))
      this.payButtonTarget.href = disabled ? "#" : `${this.summaryUrlValue}?${params.toString()}`
    }

    if (this.hasTotalTarget) {
      this.totalTarget.textContent = this.formatAmount(total)
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = selected.length ? ` · ${selected.length}` : ""
    }
  }

  formatAmount(amount) {
    const [integerPart, decimalPart] = amount.toFixed(2).split(".")
    const withSpaces = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ")

    return `${withSpaces},${decimalPart} zł`
  }
}
